import { CanvasTexture, LinearFilter, Sprite, SpriteMaterial } from "three"
import { createOffscreenCanvas } from "../../canvas/create_canvas"
import { getCanvas2dContext } from "../../canvas/get_canvas_2d_context"
import { AiOutlineVerticalAlignMiddle_d, AiOutlineVerticalAlignMiddle_h, AiOutlineVerticalAlignMiddle_w } from "../../svg/sprites_data_manual"

export const ELEVATION_CURSOR_OBJECT3D_NAME = 'Elevation'

export default function createElevationCursorSprite(): Sprite {
  // console.log('createEraseCursorSprite')

  const canvas = createOffscreenCanvas(AiOutlineVerticalAlignMiddle_w, AiOutlineVerticalAlignMiddle_h)
  const ctx = getCanvas2dContext(canvas)

  if (ctx) {
    ctx.fillStyle = 'blue'

    // // Set text properties
    // const text = 'Erase'
    // context.font = '48px Arial'
    // context.textAlign = 'center'
    // context.textBaseline = 'middle'
    // context.fillStyle = 'rgba(0,0,0,0.25)'
    // context.fillRect(0, 0, size, size)
    // const lines = text.split('\n')
    // const lineHeight = floor(size / (lines.length + 1))
    // lines.forEach((line, index) => {
    //   context.fillText(line, size / 2, (index + 1) * lineHeight)
    // })
  
    ctx.fill(AiOutlineVerticalAlignMiddle_d)
  }

  // Create a texture
  const texture = new CanvasTexture(canvas)
  texture.minFilter = LinearFilter // Prevent mipmaps
  texture.needsUpdate = true

  // Create a sprite material and sprite
  const material = new SpriteMaterial({ map: texture, transparent: true })
  const sprite = new Sprite(material)
  // sprite.scale.set(5, 5, 1) // Adjust size to match box

  // sprite.userData.vampire = true

  sprite.name = ELEVATION_CURSOR_OBJECT3D_NAME

  return sprite
}
